import { Button, Flex, Form, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { HotelSelect } from "../../common/HotelSelect";

import { mdlHotelNotConfirmCopyToOtherHotelsRequest } from "../../../models/service-models/notConfirm/HotelNotConfirmCopyToOtherHotelsRequest";
import { useMutation } from "react-query";
import { DefinitionService } from "../../../services/DefinitionService";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../../utils/ObjectHelper";
import { mdlHotelNotConfirmIdTemplateId } from "../../../models/domain/HotelNotConfirmIdTemplateId";

export type CopyNotConfirmToOtherHotelsProps = {
    fromHotelId?: string;
    notConfirmIdTemplateIds?: mdlHotelNotConfirmIdTemplateId[];
    callback?: Function;
}

export const CopyNotConfirmToOtherHotels = (props: CopyNotConfirmToOtherHotelsProps) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const { mutateAsync: copyNotConfirmToOtherHotels, isLoading: mutateLoading, data: mutatedData } = useMutation(
        (data: mdlHotelNotConfirmCopyToOtherHotelsRequest) => DefinitionService.NotConfirmCopyToOtherHotels(data as mdlHotelNotConfirmCopyToOtherHotelsRequest),
        {
            onMutate(variables) {
                variables.fromHotelId = props.fromHotelId;
                variables.notConfirmIdTemplateIds = props.notConfirmIdTemplateIds;
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body) {
                    if (data.body.isSuccessful === true) {
                        toast.success(t("common.success"));
                        props.callback && props.callback();
                    }
                    else {
                        toast.error(data.body.message);
                    }
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    )

    return (
        <>
            <Spin spinning={mutateLoading}>
                <Form
                    form={form}
                    name="copyNotConfirmToOtherHotelsForm"
                    layout="vertical"
                    onFinish={async (values) => copyNotConfirmToOtherHotels(values)}
                    autoComplete="off"
                >
                    <Form.Item<mdlHotelNotConfirmCopyToOtherHotelsRequest>
                        label={t("definitions.boards.hotels")}
                        name="toHotelIds"
                        rules={[{ required: true, message: t("common.required") }]}
                    >
                        <HotelSelect onChange={(value: string[]) => form.setFieldsValue({ hotelIds: value })} mode="multiple" />
                    </Form.Item>
                    <Form.Item>
                        <Flex align={"center"} justify="flex-end">
                            <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                        </Flex>
                    </Form.Item>
                </Form>
            </Spin>
        </>
    )
}